'use strict';

exports.__esModule = true;
exports.ModalContent = exports.DeleteButton = exports.ThumbnailContainer = undefined;

var _templateObject = _taggedTemplateLiteralLoose(['\n  0% {}\n  10%,\n  20% {\n    transform: rotate(-6deg);\n  }\n  30%,\n  50%,\n  70%,\n  90% {\n    transform: rotate(6deg);\n  }\n  40%,\n  60%,\n  80% {\n    transform: rotate(-6deg);\n  }\n  to {\n  }\n'], ['\n  0% {}\n  10%,\n  20% {\n    transform: rotate(-6deg);\n  }\n  30%,\n  50%,\n  70%,\n  90% {\n    transform: rotate(6deg);\n  }\n  40%,\n  60%,\n  80% {\n    transform: rotate(-6deg);\n  }\n  to {\n  }\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  box-shadow: ', ';\n  width: 125px;\n  height: 125px;\n  background-image: url("', '");\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n  position: relative;\n  border-radius: ', ';\n  cursor: pointer;\n'], ['\n  box-shadow: ', ';\n  width: 125px;\n  height: 125px;\n  background-image: url("', '");\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n  position: relative;\n  border-radius: ', ';\n  cursor: pointer;\n']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n  ', ' infinite 1s;\n'], ['\n  ', ' infinite 1s;\n']),
    _templateObject4 = _taggedTemplateLiteralLoose(['\n  position: absolute;\n  top: -15px;\n  right: -15px;\n  background-color: ', ';\n  width: 35px;\n  height: 35px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: ', ';\n  border: none;\n  cursor: ', ';\n  &:hover {\n    animation: ', ';\n  }\n'], ['\n  position: absolute;\n  top: -15px;\n  right: -15px;\n  background-color: ', ';\n  width: 35px;\n  height: 35px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: ', ';\n  border: none;\n  cursor: ', ';\n  &:hover {\n    animation: ', ';\n  }\n']),
    _templateObject5 = _taggedTemplateLiteralLoose(['\n  text-align: center;\n  img {\n    max-width: 100%;\n  }\n'], ['\n  text-align: center;\n  img {\n    max-width: 100%;\n  }\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

var shaking = (0, _styledComponents.keyframes)(_templateObject);

var ThumbnailContainer = exports.ThumbnailContainer = _styledComponents2.default.div(_templateObject2, function (_ref) {
  var theme = _ref.theme;
  return theme.elevationSm || '0 1px 3px rgba(16, 24, 40, 0.08)';
}, function (_ref2) {
  var bgImage = _ref2.bgImage;
  return bgImage;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.radiusMd || '10px';
});

var animation = function animation() {
  return (0, _styledComponents.css)(_templateObject3, shaking);
};

var DeleteButton = exports.DeleteButton = _styledComponents2.default.button(_templateObject4, function (_ref4) {
  var theme = _ref4.theme,
      disabled = _ref4.disabled;
  return disabled ? theme.grayE6 : theme.primary;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.borderRadiusRound;
}, function (_ref6) {
  var disabled = _ref6.disabled;
  return disabled ? 'initial' : 'pointer';
}, function (_ref7) {
  var disabled = _ref7.disabled;
  return disabled ? 'none' : animation;
});

var ModalContent = exports.ModalContent = _styledComponents2.default.div(_templateObject5);